import Vue from 'vue'
import Vuex from 'vuex'
import choosePeople from './choosePeople'
import chooseSelected from './chooseSelected'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    choosePeople,
    chooseSelected,
  },
})
